<nav class="side-nav side-nav--light side-nav--premium-rail" aria-label="Navigation">
  <p-menu [model]="sideMenuItems" [attr.data-testid]="'side-menu'"></p-menu>
</nav>
